import { render, staticRenderFns } from "./RefrigeratedGoods.vue?vue&type=template&id=6dc054ff&scoped=true&"
import script from "./RefrigeratedGoods.vue?vue&type=script&lang=js&"
export * from "./RefrigeratedGoods.vue?vue&type=script&lang=js&"
import style0 from "./RefrigeratedGoods.vue?vue&type=style&index=0&id=6dc054ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc054ff",
  null
  
)

export default component.exports